import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Nav, NavItem, NavLink } from 'reactstrap';
import Table from '../../../common/Table';
import { DEPOSIT_MIGRATION_MOVEMENT_COLUMNS } from '../../../../config/columns';
import {
  DEPOSIT_MIGRATION_MOVEMENT_CLASSIFICATION,
  DEPOSIT_MIGRATION_MOVEMENT_ROW_BACKGROUND,
  DEFAULT_PAGE_SIZE,
} from '../../../../config/constants';
import {
  getDepositMigrationMovements,
  clearDepositMigrationMovements,
} from '../../../../actions';

const ALL_TAB = 'ALL';

const depositMigrationMovementRowStyle = (row) => {
  if (!row || !row.original) return {};

  const background =
    DEPOSIT_MIGRATION_MOVEMENT_ROW_BACKGROUND[row.original.classification];

  return background ? { background } : {};
};

const TABS = [
  { value: ALL_TAB, label: 'Todos' },
  ...Object.values(DEPOSIT_MIGRATION_MOVEMENT_CLASSIFICATION),
];

const DepositMigrationMovements = ({
  depositMigrationId,
  movements,
  loading,
  dispatchGetDepositMigrationMovements,
  dispatchClearDepositMigrationMovements,
}) => {
  const [tab, setTab] = useState(ALL_TAB);

  useEffect(() => () => dispatchClearDepositMigrationMovements(), []);

  const classification = tab === ALL_TAB ? undefined : tab;

  const data = movements.get('content') || [];
  const pages = movements.get('totalPages') || null;
  const defaultPageSize = movements.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <>
      <h3 className="mb-2">Movimientos del archivo</h3>

      <Nav tabs>
        {TABS.map(({ value, label }) => (
          <NavItem key={value}>
            <NavLink
              href="#"
              active={tab === value}
              onClick={(event) => {
                event.preventDefault();
                setTab(value);
              }}
            >
              {label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <Table
        key={tab}
        columns={DEPOSIT_MIGRATION_MOVEMENT_COLUMNS}
        data={data}
        pages={pages}
        defaultPageSize={defaultPageSize}
        loading={loading}
        fetchData={dispatchGetDepositMigrationMovements}
        params={{ depositMigrationId, classification }}
        groupedColumns
        enableColumnHoverPopover
        generateStyle={depositMigrationMovementRowStyle}
      />
    </>
  );
};

DepositMigrationMovements.propTypes = {
  depositMigrationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  movements: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  dispatchGetDepositMigrationMovements: PropTypes.func.isRequired,
  dispatchClearDepositMigrationMovements: PropTypes.func.isRequired,
};

DepositMigrationMovements.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ SalesUnit }) => ({
  movements: SalesUnit.DepositMigration.getIn(['movements', 'content']),
  loading: SalesUnit.DepositMigration.getIn(['movements', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetDepositMigrationMovements: getDepositMigrationMovements,
  dispatchClearDepositMigrationMovements: clearDepositMigrationMovements,
};

export { DepositMigrationMovements };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DepositMigrationMovements);
